export default __webpack_public_path__ + "static/media/stop.74a289fa.svg";